/* Step 2 - Scent Selector JS (Dynamic) - assets/bundle-step2-v3.js */
(function() {
  'use strict';
  var CONFIG = window.S2_CONFIG || {};

  /* Parse query params from step 1 */
  var params = new URLSearchParams(window.location.search);
  var productHandle = params.get('handle') || '';
  var minNeeded = parseInt(params.get('cartridges')) || 4;
  var initialGifts = parseInt(params.get('gifts')) || 0;
  var discount = params.get('discount') || '0';
  var sellingPlanId = params.get('selling_plan') || '';

  console.log('[S2] Init: handle=' + productHandle + ' minNeeded=' + minNeeded + ' gifts=' + initialGifts + ' discount=' + discount + ' sellingPlan=' + sellingPlanId);

  /* Set navbar text */
  var neededEl = document.getElementById('s2-total-needed');
  if (neededEl) neededEl.textContent = minNeeded;
  var pluralEl = document.getElementById('s2-plural');
  if (pluralEl) pluralEl.textContent = minNeeded === 1 ? '' : 's';

  /* State */
  var giftCards = document.querySelectorAll('[data-s2-gift]');
  var filterSection = document.getElementById('s2-filter-section');
  var selectedFilter = null;
  var totalSelected = 0;
  var scentCards = []; /* populated after fetch */
  var productTitle = ''; /* set when product loads */

  function getGiftsForCount(count) {
    /* Use the higher of: scents selected OR initial gifts from step 1.
       This ensures gifts they qualified for on step 1 stay unlocked,
       and adding more scents can unlock additional ones. */
    var scentGifts = count >= 4 ? 4 : count;
    return Math.max(scentGifts, initialGifts);
  }

  function getQty(card) {
    return parseInt(card.querySelector('[data-s2-qty]').textContent) || 0;
  }

  function setQty(card, qty) {
    var qtyEl = card.querySelector('[data-s2-qty]');
    var addBtn = card.querySelector('[data-s2-add]');
    var counter = card.querySelector('.s2__scent-counter');
    qtyEl.textContent = qty;
    card.classList.toggle('s2__scent--active', qty > 0);
    if (qty > 0) {
      if (addBtn) addBtn.style.display = 'none';
      if (counter) counter.style.display = '';
    } else {
      if (addBtn) addBtn.style.display = '';
      if (counter) counter.style.display = 'none';
    }
  }

  function recalc() {
    totalSelected = 0;
    scentCards.forEach(function(c) { totalSelected += getQty(c); });
    var currentGifts = getGiftsForCount(totalSelected);

    /* Gift lock/unlock */
    giftCards.forEach(function(g) {
      var giftNum = parseInt(g.getAttribute('data-s2-gift'));
      g.classList.toggle('s2__gift--locked', currentGifts < giftNum);
    });

    /* HVAC filter visibility */
    var filterGiftNum = CONFIG.filterGiftNumber || 3;
    var showFilter = currentGifts >= filterGiftNum;
    if (filterSection) {
      filterSection.style.display = showFilter ? '' : 'none';
      if (!showFilter) {
        selectedFilter = null;
        document.querySelectorAll('[data-s2-filter]').forEach(function(o) {
          o.classList.remove('s2__filter-option--active');
        });
      }
    }

    /* Gift count */
    var giftCountEl = document.getElementById('s2-gift-count');
    if (giftCountEl) giftCountEl.textContent = currentGifts;

    /* Order summary */
    var itemsEl = document.getElementById('s2-summary-items');
    if (itemsEl) {
      var html = '';
      /* Show product name as header */
      if (productTitle) {
        html += '<div class="s2__summary-item" style="font-weight:800;margin-bottom:4px;"><span class="s2__summary-item-name">' + productTitle + '</span><span></span></div>';
      }
      scentCards.forEach(function(c) {
        var q = getQty(c);
        if (q > 0) {
          html += '<div class="s2__summary-item"><span class="s2__summary-item-name" style="padding-left:8px;">' +
            c.getAttribute('data-s2-title') + '</span><span class="s2__summary-item-qty">x' + q + '</span></div>';
        }
      });
      if (!html) html = '<div style="font-size:0.85rem;color:#999;">No scents selected yet</div>';
      itemsEl.innerHTML = html;
    }

    var giftsEl = document.getElementById('s2-summary-gifts');
    if (giftsEl) {
      var ghtml = '';
      var filterGiftNum = CONFIG.filterGiftNumber || 3;
      giftCards.forEach(function(g) {
        var giftNum = parseInt(g.getAttribute('data-s2-gift'));
        /* Skip gift 4 (HVAC filter) since it's shown via the filter picker below */
        if (giftNum === 4) return;
        if (currentGifts >= giftNum) {
          var title = g.querySelector('.s2__gift-title');
          ghtml += '<div class="s2__summary-gift"><span>' + (title ? title.textContent : 'Free Gift') + '</span><span>FREE</span></div>';
        }
      });
      /* Show HVAC filter as single line with size if selected */
      if (showFilter && selectedFilter) {
        ghtml += '<div class="s2__summary-gift"><span>HVAC Air Filter (' + selectedFilter.getAttribute('data-s2-filter-label').split(' /')[0] + ')</span><span>FREE</span></div>';
      } else if (showFilter) {
        ghtml += '<div class="s2__summary-gift"><span>HVAC Air Filter (select size above)</span><span>FREE</span></div>';
      }
      giftsEl.innerHTML = ghtml;
    }

    /* CTA */
    var cta = document.getElementById('s2-cta');
    var needsFilter = showFilter && !selectedFilter;
    var ready = totalSelected >= minNeeded && !needsFilter;
    if (cta) {
      cta.disabled = !ready;
      cta.classList.toggle('s2__cta--ready', ready);
      var ctaText = document.getElementById('s2-cta-text');
      if (ctaText) {
        if (totalSelected < minNeeded) {
          var remaining = minNeeded - totalSelected;
          ctaText.textContent = 'Select ' + remaining + ' more scent' + (remaining > 1 ? 's' : '');
        } else if (needsFilter) {
          ctaText.textContent = 'Choose your filter size above';
        } else {
          ctaText.textContent = CONFIG.ctaReadyText || 'Complete Your Order';
        }
      }
    }
  }

  /* Build a scent row element from variant data */
  function buildScentRow(variant, product) {
    var title = variant.title || 'Scent';
    var imgSrc = '';
    if (variant.featured_image && variant.featured_image.src) {
      imgSrc = variant.featured_image.src.replace(/(\.\w+)\?/, '_150x$1?');
    } else if (product.image && product.image.src) {
      imgSrc = product.image.src.replace(/(\.\w+)\?/, '_150x$1?');
    }

    /* Check for scent override data */
    var override = CONFIG.scentNotes && CONFIG.scentNotes[title];
    var notes = override ? override.notes : '';
    var badge = override ? override.badge : '';
    var badgePos = override ? override.badgePos : 'top';
    var badgeColor = override ? override.badgeColor : 's2__badge-red';
    var badgeTopColor = override ? override.badgeTopColor : 's2__badge-top-red';

    var row = document.createElement('div');
    row.className = 's2__scent';
    row.setAttribute('data-s2-scent', '');
    row.setAttribute('data-s2-variant', variant.id);
    row.setAttribute('data-s2-title', title);

    var html = '';

    if (badge && badgePos === 'side') {
      html += '<div class="s2__scent-badge-side ' + badgeColor + '"><span>' + badge + '</span></div>';
    }
    if (badge && badgePos === 'top') {
      html += '<div class="s2__scent-badge-top ' + badgeTopColor + '">' + badge + '</div>';
    }

    html += '<div class="s2__scent-img">';
    if (imgSrc) {
      html += '<img src="' + imgSrc + '" alt="' + title + '" loading="lazy" width="75" height="75">';
    } else {
      html += '<div class="s2__scent-placeholder">🌿</div>';
    }
    html += '</div>';

    html += '<div class="s2__scent-info">';
    html += '<div class="s2__scent-name">' + title + '</div>';
    if (notes) html += '<div class="s2__scent-notes">' + notes + '</div>';
    html += '</div>';

    html += '<div class="s2__scent-actions">';
    html += '<button class="s2__scent-btn-add" data-s2-add type="button">Add +</button>';
    html += '<div class="s2__scent-counter" style="display:none;">';
    html += '<button class="s2__scent-btn-pm" data-s2-minus type="button">&minus;</button>';
    html += '<span class="s2__scent-qty" data-s2-qty>0</span>';
    html += '<button class="s2__scent-btn-pm" data-s2-plus type="button">&plus;</button>';
    html += '</div></div>';

    row.innerHTML = html;

    /* Attach event listeners */
    var addBtn = row.querySelector('[data-s2-add]');
    var minusBtn = row.querySelector('[data-s2-minus]');
    var plusBtn = row.querySelector('[data-s2-plus]');

    if (addBtn) addBtn.addEventListener('click', function() { setQty(row, getQty(row) + 1); recalc(); });
    if (plusBtn) plusBtn.addEventListener('click', function() { setQty(row, getQty(row) + 1); recalc(); });
    if (minusBtn) minusBtn.addEventListener('click', function() {
      var q = getQty(row);
      if (q > 0) setQty(row, q - 1);
      recalc();
    });

    return row;
  }

  /* Build filter size option */
  function buildFilterOption(variant) {
    var opt = document.createElement('div');
    opt.className = 's2__filter-option';
    opt.setAttribute('data-s2-filter', '');
    opt.setAttribute('data-s2-filter-variant', variant.id);
    opt.setAttribute('data-s2-filter-label', variant.title);
    opt.innerHTML =
      '<div class="s2__filter-radio"></div>' +
      '<div class="s2__filter-content"><div class="s2__filter-size">' + variant.title + '</div></div>' +
      '<div class="s2__filter-price">FREE</div>';
    opt.addEventListener('click', function() {
      document.querySelectorAll('[data-s2-filter]').forEach(function(o) { o.classList.remove('s2__filter-option--active'); });
      opt.classList.add('s2__filter-option--active');
      selectedFilter = opt;
      recalc();
    });
    return opt;
  }

  /* Fetch product and build UI */
  function loadProduct() {
    if (!productHandle) {
      document.getElementById('s2-loading').innerHTML =
        '<p style="color:#c00;font-weight:700;">Error: No product handle in URL.</p>' +
        '<p>Make sure Step 1 is passing the handle parameter.</p>';
      return;
    }

    fetch('/products/' + productHandle + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('Product not found: ' + productHandle);
        return r.json();
      })
      .then(function(product) {
        console.log('[S2] Product loaded:', product.title, '(' + product.variants.length + ' variants)');
        productTitle = product.title;

        var container = document.getElementById('s2-scents');
        var loading = document.getElementById('s2-loading');
        if (loading) loading.remove();

        /* Filter out excluded variants */
        var excludes = CONFIG.excludeVariants || [];
        var variants = product.variants.filter(function(v) {
          return excludes.indexOf(v.title) === -1;
        });

        if (variants.length === 0) {
          container.innerHTML = '<p style="padding:2rem;text-align:center;color:#999;">No scent variants found for this product.</p>';
          return;
        }

        /* Build scent rows */
        variants.forEach(function(v) {
          var row = buildScentRow(v, product);
          container.appendChild(row);
          scentCards.push(row);
        });

        recalc();
      })
      .catch(function(err) {
        console.error('[S2] Error loading product:', err);
        var loading = document.getElementById('s2-loading');
        if (loading) loading.innerHTML = '<p style="color:#c00;">Error loading product. Please go back and try again.</p>';
      });
  }

  /* Fetch HVAC filter product */
  function loadFilterProduct() {
    var handle = CONFIG.filterProductHandle || 'replacement-hvac-air-filter';
    fetch('/products/' + handle + '.js')
      .then(function(r) {
        if (!r.ok) throw new Error('Filter product not found');
        return r.json();
      })
      .then(function(product) {
        console.log('[S2] Filter product loaded:', product.title, '(' + product.variants.length + ' variants)');
        var grid = document.getElementById('s2-filter-grid');
        if (!grid) return;
        product.variants.forEach(function(v) {
          grid.appendChild(buildFilterOption(v));
        });
      })
      .catch(function(err) {
        console.error('[S2] Error loading filter product:', err);
      });
  }

  /* ADD TO CART */
  var cta = document.getElementById('s2-cta');
  if (cta) cta.addEventListener('click', function() {
    if (cta.disabled) return;
    cta.classList.add('s2__cta--loading');
    var ctaText = document.getElementById('s2-cta-text');
    if (ctaText) ctaText.textContent = 'Adding...';

    var items = [];
    var currentGifts = getGiftsForCount(totalSelected);

    /* Add selected scent variants with selling plan for subscription */
    scentCards.forEach(function(card) {
      var q = getQty(card);
      var vid = card.getAttribute('data-s2-variant');
      if (q > 0 && vid) {
        var item = { id: parseInt(vid), quantity: q };
        if (sellingPlanId) item.selling_plan = parseInt(sellingPlanId);
        items.push(item);
      }
    });

    /* Auto-add gift products based on unlock tier.
       Gift 1 = Free Shipping ($0 variant).
       Gift 2 = Scenta Home Audit Gift ($0 variant).
       Gift 3 = Mystery Gift ($0 variant).
       Gift 4 = HVAC Filter (customer picks size, handled separately below). */
    var GIFT_VARIANTS = {
      1: 52700162031905,  /* Free Shipping */
      2: 52699876524321,  /* Scenta Home Audit Gift */
      3: 52699515584801   /* Mystery Gift */
    };

    for (var giftNum in GIFT_VARIANTS) {
      if (currentGifts >= parseInt(giftNum)) {
        items.push({ id: GIFT_VARIANTS[giftNum], quantity: 1 });
      }
    }

    /* Add HVAC filter variant if selected (gift 4, already $0 from the free gift product) */
    if (selectedFilter) {
      var fv = selectedFilter.getAttribute('data-s2-filter-variant');
      if (fv) items.push({ id: parseInt(fv), quantity: 1 });
    }

    console.log('[S2] Adding to cart:', JSON.stringify(items));

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { if (!r.ok) throw new Error('Failed'); return r.json(); })
    .then(function() {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            offerType: 'bundle-lp-step2',
            discountType: discount,
            cartridgesSelected: String(totalSelected),
            giftsUnlocked: String(currentGifts)
          }
        })
      });
    })
    .then(function() { window.location.href = CONFIG.cartRedirect || '/cart'; })
    .catch(function(err) {
      console.error('[S2] Cart error:', err);
      cta.classList.remove('s2__cta--loading');
      if (ctaText) ctaText.textContent = CONFIG.ctaReadyText || 'Complete Your Order';
      alert('Something went wrong. Please try again.');
    });
  });

  /* Back button */
  var backBtn = document.getElementById('s2-back');
  if (backBtn && backBtn.getAttribute('href') === '#') {
    backBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (document.referrer) window.location.href = document.referrer;
      else window.history.back();
    });
  }

  /* Init: load both products */
  loadProduct();
  loadFilterProduct();
  recalc();
})();
